export const navItems = [
    { text: 'Home', link: '/' },
    { text: 'Services', link: '/services/bank-account-opening' },
    { text: 'Business Setup', link: '/business-setup' },
    { text: 'Banking', link: '/banking' },
    { text: 'Pricing', link: '/pricing' },
    { text: 'About us', link: '/about-us' },
    { text: 'Blog', link: '/blog' },
    { text: 'Contact Us', link: '/contact' },
];